import { InMemoryCache } from "@apollo/client";
import { relayStylePagination } from "@apollo/client/utilities";

export const createCache = () => {
  const cache = new InMemoryCache({
    typePolicies: {
      Query: {
        fields: {
          receptionStandbys: relayStylePagination([
            "date",
            "settlementActionRequired",
            "someActionRequired",
            "noActionRequired",
            "sortBy",
          ]),
        },
      },
    },
  });

  return cache;
};
